module.exports = __webpack_public_path__ + "img/als.e12ab6da.svg";